import { Type } from 'class-transformer';
import type {
  XingId,
  AccountSettings,
  Feature,
  ProfileImage,
  EmailSetting,
  Maybe,
  XingIdOccupation,
} from '../../interfaces/xingOne';

interface User
  extends Pick<XingId, 'id' | 'firstName' | 'lastName' | 'displayName'> {
  profileImage: Maybe<Array<Maybe<ProfileImage>>>;
  ocupations: XingIdOccupation[];
}

class XingUser implements User {
  ocupations: XingIdOccupation[];
  profileImage: ProfileImage[];
  id: string | number;
  firstName: string;
  lastName: string;
  displayName: string;
}

interface Account {
  language: AccountSettings['language']['value'];
  email: EmailSetting;
}
class UserAccount implements Account {
  email: EmailSetting;
  language: string;
}

class Features implements Feature {
  isXingEmployee: boolean;
  isCraUser: boolean;
  isXtpUser: boolean;
}
class Customer {
  @Type(() => Features)
  features: Features;

  @Type(() => UserAccount)
  accountSettings: UserAccount;

  @Type(() => XingUser)
  profile: XingUser;

  featureSwitches: string[];
}

export { Customer };
